export default {
  title: 'Paramètres',
  fields: {
    discount_type: {
      label: 'Type de remise',
    },
  },
  buttons: {
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  toasts: {
    update_successful: 'Mise à jour réussie',
    updated_failed: 'Échec de la mise à jour',
  },
};
